<template>
  <slide-out
    dock="right"
    :size="sideOutCurrentSize"
    :min-size="sideOutMinSize"
    id="edit-task-slideout"
    ref="taskSlideout"
    :allow-resize="nested ? false : true"
    :append-to="nested ? '' : '#app'"
    :style="besideAssistantStyle"
    :visible.sync="slideouts.active"
    v-on:close="onSlideoutClosing"
    @resize="OnResize">
    <template v-slot:header>
      <h3 class="font-weight-bold pa-1 sideOutHeaderTitle" small>
        {{ isNew && !isBulk ? 'Add Task' : 'Edit Task' }}
      </h3>
      <h3 v-if="isFetching" class="font-weight-bold pa-1" small>
        <v-progress-circular :size="16" width="2" indeterminate class="mr-1"></v-progress-circular>
        Fetching Task ...
      </h3>
      <!-- <h3 v-else-if="selected.id" class="font-weight-bold pa-1" small>
        <v-icon left>mdi-pencil-box-outline</v-icon> Update Task
      </h3> -->

      <v-btn class="font-weight-bold" color="mid-grey2" large @click="discard" icon>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>

    <div id="EditTabs-wrapper" style="height: calc(100% - 60px)">
      <!-- <div class="text-center d-flex flex-column" v-if="isFetching">
        <img width="300" src="/img/loading.svg" class="py-5 my-8" style="opacity: 0.54" />
        <p class="font-weight-medium">Loading task data...</p>
      </div> -->

      <v-tabs
        v-model="selectedTab"
        fixed-tabs
        :grow="isNew"
        @change="onSelectedTabChanged"
        id="task-edit-tab"
        style="height: 100%">
        <v-tab>General</v-tab>
        <v-tab id="comments-tab-header" :disabled="isNew && isBulk">Comments</v-tab>
        <v-tab :disabled="isNew && isBulk">History</v-tab>
        <v-tab :disabled="isNew && isBulk">Documents</v-tab>
        <v-tab-item>
          <v-form ref="editTaskForm" class="pa-4" v-model="valid">
            <v-row>
              <v-col class="pb-0" cols="12">
                <div class="d-flex align-center">
                  <v-text-field
                    v-if="!isBulk"
                    :color="selected.color && selected.color.hex ? selected.color.hex : selected.color"
                    hide-details
                    outlined
                    dense
                    label="Title"
                    :readonly="!allowModify"
                    :rules="[formRules.required]"
                    v-model="selected.text"
                    class="flex-grow-1">
                  </v-text-field>
                  <color-picker-button
                    v-model="selected.color"
                    :attach="true"
                    :allowClear="true"
                    :disabled="!allowModify"
                    :colorSwatches="colorSwatches">
                  </color-picker-button>
                </div>
              </v-col>
            </v-row>
            <v-row class="d-flex align-center px-6 pb-3 my-4">
              <v-col cols="12" class="d-flex flex-column sliderContainer pb-0">
                <label class="font-weight-bold pb-3">Progress</label>
                <div class="d-flex w-100 align-center">
                  <span
                    class="font-weight-bold progressValue me-2"
                    style="color: var(--v-primary-base)"
                    >{{ selected.progress }}%</span
                  >
                  <v-slider
                    class="mr-2"
                    dense
                    height="12"
                    hide-details
                    v-model="selected.progress"
                    min="0"
                    max="100"
                    tick-size="5"
                    color="primary"
                    track-color="light-grey"
                    :disabled="selected.isParent"
                    step="1"></v-slider>
                </div>
              </v-col>
            </v-row>
            <v-expansion-panels accordion flat class="editTaskPanels">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Task Details
                  <template v-slot:actions>
                    <v-icon color="mid-grey2" large> mdi-chevron-right</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col class="pb-0">
                      <v-text-field
                        v-if="!isBulk"
                        hide-details
                        color="primary"
                        outlined
                        v-model="selected.friendlyId"
                        dense
                        readonly
                        label="Task ID"></v-text-field>
                    </v-col>
                    <v-col class="pb-0">
                      <v-text-field
                        v-if="!isBulk"
                        hide-details
                        outlined
                        dense
                        readonly
                        label="Board Name"
                        v-model="taskType.name"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pb-0" cols="12">
                      <v-textarea
                        outlined
                        dense
                        clearable
                        hide-details
                        rows="6"
                        row-height="25"
                        no-resize
                        :readonly="!allowModify"
                        label="Description"
                        placeholder="Enter Task Description"
                        v-model="selected.taskDescription">
                      </v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pb-0" cols="12">
                      <single-value-selector
                        attach
                        :readonly="!allowModify"
                        v-model="selected.projectId"
                        :url="'api/appprojects/typehead'"
                        :params="{ facilityId: $route.params.id }"
                        itemText="name"
                        itemValue="id"
                        :defaultStyle="{ outlined: true, clearable: true }"
                        label="Project"></single-value-selector>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pb-0">
                      <v-select
                        attach
                        :readonly="!allowModify"
                        :items="taskType.statuses"
                        label="Task Status"
                        outlined
                        dense
                        clearable
                        item-value="id"
                        item-text="name"
                        hide-details
                        v-model="selected.statusId">
                      </v-select>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header
                  >Personnel
                  <template v-slot:actions>
                    <v-icon color="mid-grey2" large> mdi-chevron-right</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col class="pb-0" cols="12">
                      <UserSelector
                        :hide-details="true"
                        v-model="selected.participantsIds"
                        label="Participants"
                        multiple>
                      </UserSelector>
                    </v-col>
                    <v-col class="pb-0" cols="6">
                      <UserSelector
                        :readonly="!allowModify"
                        :hide-details="true"
                        v-if="selected"
                        v-model="selected.reportedById"
                        label="Reported By">
                      </UserSelector>
                    </v-col>
                    <v-col class="pb-0" cols="6">
                      <UserSelector
                        :readonly="!allowModify"
                        v-if="selected"
                        :hide-details="true"
                        v-model="selected.approvedById"
                        label="Approved By">
                      </UserSelector>
                    </v-col>
                    <v-col class="pb-0" cols="6"> </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header
                  >Links
                  <template v-slot:actions>
                    <v-icon color="mid-grey2" large> mdi-chevron-right</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content eager>
                  <forge-tags-selector
                    v-if="tagPickerRequested && selected"
                    :allowModify="!allowModify"
                    attach
                    v-model="selected.forgeTagsIds"></forge-tags-selector>

                  <!-- Wave C-ι (task side): link this task to monitoring CMLs.
                       Tag-scoped — the Tags above drive the options. Staged
                       locally; persisted after the task is saved. `eager` keeps
                       the ref mounted so the save-hook can commit even if Links
                       was never expanded. -->
                  <TaskCmlLinksSection
                    v-if="!isBulk"
                    ref="taskCmlLinks"
                    :key="scopeBuilderKey"
                    class="mt-4"
                    :task-id="task && task.id ? task.id : ''"
                    :is-new="isNew"
                    :tag-ids="(selected && selected.forgeTagsIds) || []"
                    :seed-scopes="seedCmlScopes"
                    @scopes-dirty="slideouts.scopesDirty = $event" />
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header
                  >Dates and Duration
                  <template v-slot:actions>
                    <v-icon color="mid-grey2" large> mdi-chevron-right</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row style="position: relative">
                    <v-col class="pr-4 pb-0">
                      <DatePicker
                        :top="true"
                        :allowModify="!allowModify"
                        v-model="selected.start_date"
                        :rules="[formRules.required]"
                        label="Planned Start Date">
                      </DatePicker>
                    </v-col>
                    <v-col class="pb-0">
                      <DatePicker
                        :top="true"
                        :allowModify="!allowModify"
                        :minDate="selected.start_date"
                        v-model="selected.end_date"
                        :rules="[formRules.required]"
                        label="Planned End Date"></DatePicker>
                    </v-col>
                  </v-row>
                  <v-row style="position: relative">
                    <v-col class="pr-4 pb-0">
                      <DatePicker
                        :top="true"
                        :allowModify="!allowModify"
                        v-model="selected.actualStartDate"
                        label="Actual Start Date"></DatePicker>
                    </v-col>
                    <v-col class="pb-0">
                      <DatePicker
                        :top="true"
                        :allowModify="!allowModify"
                        v-model="selected.actualEndDate"
                        label="Actual End Date"
                        :minDate="selected.actualStartDate"></DatePicker>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel v-for="section in validSections" :key="section.id">
                <v-expansion-panel-header
                  >{{ section.name }}
                  <template v-slot:actions>
                    <v-icon color="mid-grey2" large> mdi-chevron-right</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row style="position: relative" v-if="section.fields">
                    <v-col
                      :cols="field.fieldType == TaskFieldType.Users ? 12 : 6"
                      class="pr-4 pb-0"
                      v-for="field in section.fields.filter((e) => e.isEnabled)"
                      :key="field.id">
                      <v-text-field
                        clearable
                        hide-details
                        :readonly="!allowModify"
                        v-if="[TaskFieldType.Text, TaskFieldType.Number].includes(field.fieldType)"
                        dense
                        :type="field.fieldType == TaskFieldType.Text ? 'text' : 'number'"
                        outlined
                        :label="field.label"
                        :placeholder="field.placeholder"
                        v-model="customFields[field.id]"></v-text-field>
                      <DatePicker
                        :top="true"
                        :allowModify="!allowModify"
                        v-else-if="field.fieldType == TaskFieldType.Date"
                        :label="field.label"
                        :placeholder="field.placeholder"
                        v-model="customFields[field.id]" />
                      <v-select
                        :readonly="!allowModify"
                        :items="yesNo"
                        outlined
                        clearable
                        attach
                        dense
                        hide-details
                        v-else-if="field.fieldType == TaskFieldType.Boolean"
                        :label="field.label"
                        :placeholder="field.placeholder"
                        v-model="customFields[field.id]"></v-select>
                      <!-- if field.fieldType == 6 ==>( DropDown )  -->
                      <v-select
                        :readonly="!allowModify"
                        v-else-if="field.fieldType == TaskFieldType.Dropdown"
                        :items="field.options"
                        item-text="value"
                        item-value="id"
                        v-model="customFields[field.id]"
                        :label="field.label"
                        :placeholder="field.placeholder"
                        outlined
                        attach
                        clearable
                        hide-details
                        dense></v-select>
                      <!-- if field.fieldType == 8  ==>( Plan3D )  -->
                      <v-select
                        :readonly="!allowModify"
                        v-else-if="field.fieldType == TaskFieldType.Plan3D"
                        :items="field.options"
                        item-text="value"
                        item-value="id"
                        v-model="customFields[field.id]"
                        :label="field.label"
                        :placeholder="field.placeholder"
                        hide-details
                        outlined
                        attach
                        clearable
                        dense>
                        <template v-slot:item="{ item }">
                          <div class="d-flex align-center">
                            <div class="color-border mr-2" :style="{ backgroundColor: item.color || '#FFFFFF' }"></div>
                            <div>{{ item.value }}</div>
                          </div>
                        </template>
                        <template v-slot:selection="{ item }">
                          <div class="d-flex align-center">
                            <div class="color-border mr-2" :style="{ backgroundColor: item.color || '#FFFFFF' }"></div>
                            <div>{{ item.value }}</div>
                          </div>
                        </template>
                      </v-select>
                      <!-- if field.fieldType == 7  ==>( User )  -->
                      <UserSelector
                        :readonly="!allowModify"
                        v-else-if="field.fieldType == TaskFieldType.Users"
                        :label="field.label"
                        :placeholder="field.placeholder"
                        hide-details
                        v-model="customFields[field.id]"></UserSelector>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-form>

          <!-- information section start -->

          <!-- information section end -->
        </v-tab-item>
        <v-tab-item>
          <TaskComments ref="comments" @onAdd="onAddComment" @onUpdate="onUpdateComment" @onDelete="onDeleteComment"></TaskComments>
        </v-tab-item>
        <v-tab-item>
          <TaskHistory ref="history"></TaskHistory>
        </v-tab-item>
        <v-tab-item>
          <TaskDocuments ref="documents"></TaskDocuments>
        </v-tab-item>
      </v-tabs>
    </div>

    <template v-slot:footer>
      <v-card-actions class="d-flex flex-column">
        <v-btn class="mb-2" outlined rounded color="primary" @click="closeUpdateSlideout()" block>
          <v-icon left>mdi-chevron-left</v-icon> Close
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          block
          rounded
          color="primary"
          v-has="permissions.Tasks.Create"
          v-if="isNew"
          :disabled="!valid || slideouts.isLoading || (!slideouts.hasChanges && !slideouts.scopesDirty)"
          @click="updateConfirmed()"
          :loading="slideouts.isLoading">
          <v-icon left>{{ isNew && !isBulk ? 'mdi-plus' : 'mdi-check' }}</v-icon>
          {{ isNew && !isBulk ? 'Create' : 'Save Changes' }}
        </v-btn>
        <v-btn
          block
          rounded
          v-else
          color="primary"
          v-has="permissions.Tasks.Update"
          :disabled="!valid || slideouts.isLoading || (!slideouts.hasChanges && !slideouts.scopesDirty)"
          @click="updateConfirmed()"
          :loading="slideouts.isLoading">
          <v-icon left>{{ isNew ? 'mdi-plus' : 'mdi-check' }}</v-icon>
          {{ 'Save Changes' }}
        </v-btn>
      </v-card-actions>
    </template>
  </slide-out>
</template>

<script>
  import ForgeTagsSelector from '@Share/components/ForgeTagsSelector.vue';
  import formRules from '@Share/config/form-rules';
  import ApiService from '../service/gantt.service';
  import { $handleError, $isEqual, $formatDate, $deepCompare } from '@Utils';
  import DatePicker from '@Share/components/VDatePicker';
  import UserSelector from '@Share/components/UserSelector';
  import TaskComments from '../components/TaskComments.vue';
  import TaskHistory from '../components/TaskHistory.vue';
  import TaskDocuments from '../components/TaskDocuments.vue';
  import TaskCmlLinksSection from '../components/TaskCmlLinksSection.vue';
  import moment from 'dayjs';
  import { mapGetters } from 'vuex';
  import { TaskFieldType } from '@Share/config/enums';
  import permissions from '@Share/config/permissions';
  import { $has } from '@/utils';
  import ColorPickerButton from '@Share/components/ColorPickerButton.vue';
  import { registerOpenTask, taskSubjectName } from '@/actions/openTask';
  import { besidePanelStyle } from '@Assistant/domain/besidePanel';

  var scheduler = scheduler;
  import SingleValueSelector from '@Share/components/SingleValueSelector.vue';
  var gantt = gantt;
  export default {
    name: 'edit-task',
    data() {
      return {
        permissions,
        selectedTab: 0,
        customFields: {},
        valid: false,
        formRules,
        taskTypeId: '',
        task: {},
        TaskFieldType,
        isNew: false,
        fromIndexPage: false,
        isFetching: false,
        selected: {},
        modal: false,
        selectedCemented: {},
        customFieldsCemented: {},
        colorSwatches: [
          ['#FF0000', '#AA0000', '#550000'],
          ['#FFFF00', '#AAAA00', '#555500'],
          ['#00FF00', '#00AA00', '#005500'],
          ['#00FFFF', '#00AAAA', '#005555'],
          ['#0000FF', '#0000AA', '#000055'],
        ],
        yesNo: [
          {
            text: 'Yes',
            value: 1,
          },
          {
            text: 'No',
            value: 0,
          },
        ],
        options: {
          itemsPerPage: 1000,
        },
        // The tag picker loads every tag of the facility group (100k+ on large sites) when it is created.
        // EditTask is mounted while closed (MainView, task views), so create the picker only once the
        // slide-out has been opened, and keep it afterwards so reopening does not refetch.
        tagPickerRequested: false,
        slideouts: {
          active: false,
          isLoading: false,
          isClosing: false,
          hasChanges: false,
          // Set from TaskCmlLinksSection's `scopes-dirty` event so Save enables when
          // ONLY monitoring scopes changed (checkForChanges tracks task fields only).
          scopesDirty: false,
        },
        allowModify: false,
        isBulk: false,
        changes: {},
        tasksArray: [],
        // Bumped on every slideout open so TaskCmlLinksSection remounts and reloads
        // its links from the server — prevents stale scope state across reopens.
        scopeBuilderKey: 0,
        // Scopes to pre-link when EditTask is opened for "create from monitoring".
        // Empty for every other open path (normal create / edit).
        seedCmlScopes: [],
      };
    },
    props: {
      nested: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      taskType() {
        let type;
        type = this.taskTypes.find((e) => e.id == this.taskTypeId) || { statuses: [] };
        return type;
      },
      ...mapGetters('TASKSTATUS', {
        taskStatusloading: 'GET_LOADING',
        taskStatuses: 'GET_ENTRIES',
        tasksCollectionByIDs: 'GET_ENTRIES_COLLECTION',
      }),
      ...mapGetters('TASK_MANAGER', {
        taskTypes: 'GET_ENTRIES',
      }),
      validSections() {
        return this.taskType?.sections?.filter((section) => section.fields.length > 0) ?? [];
      },
      sideOutMinSize: {
        get() {
          return this.$store.getters['GET_SIDOUT_MINSIZE'];
        },
        set(val) {
          this.$store.commit('SET_SIDOUT_MINSIZE', val);
        },
      },
      /** Beside the AVA side panel, not over it, so the chat stays usable while a task is open. */
      besideAssistantStyle() {
        return besidePanelStyle({ nested: this.nested });
      },
      sideOutCurrentSize: {
        get() {
          return this.$store.getters['GET_SIDOUT_CURRENTSIZE'];
        },
        set(val) {
          this.$store.commit('SET_SIDOUT_CURRENTSIZE', val);
        },
      },
      fields() {
        if (this.taskType && this.taskType.sections)
          return this.taskType.sections.map((e) => e.fields).flat();
        else return [];
      },
      selectedTasks: {
        get() {
          return this.$store.getters['GANTT/GET_SELECTED_TASKS'];
        },
        set(val) {
          this.$store.commit('GANTT/SET_SELECTED_TASKS', val);
        },
      },
      taskColor: {
        get() {
          return this.selected.color;
        },
        set(val) {
          this.selected.color = val; 
        }
      }
    },
    mounted() {},
    beforeDestroy() {
      this.forgetOpenTask();
    },
    created() {
      this.allowModify = $has([permissions.Tasks.Create, permissions.Tasks.Update], true);
    },
    methods: {
      discard() {
        this.$emit('discard', this.selected.id);
        this.closeUpdateSlideout();
      },
      onSlideoutClosing() {
        this.$emit('close');
        this.closeUpdateSlideout();
      },
      checkAttributes(array, attribute) {
        return array.every((item) => {
          if (Array.isArray(item[attribute])) {
            // Check if both arrays have the same length and elements
            return (
              item[attribute].length === array[0][attribute].length &&
              item[attribute].every((id, index) => id === array[0][attribute][index])
            );
          } else {
            // For non-array attributes, check equality
            return item[attribute] === array[0][attribute];
          }
        });
      },
      checkCustomFieldsAttributes(array, fieldId) {
        return array.every((item) => {
          const customField = item.customFields.find((field) => field.fieldId === fieldId);
          return (
            customField &&
            customField.value ===
              array[0].customFields.find((field) => field.fieldId === fieldId).value
          );
        });
      },
      getChangedAttributes(currentObj, previousObj) {
        let changedAttributes = {};

        for (let key in currentObj) {
          if (currentObj[key] !== previousObj[key]) {
            changedAttributes[key] = currentObj[key];
          }
        }

        return changedAttributes;
      },
      updateConfirmed() {
        this.slideouts.isLoading = true;
        setTimeout(() => {
          this.selected.color = this.selected.color?.hex 
            ? this.selected.color.hex 
            : this.selected.color;

          let task = structuredClone(this.selected);
          task.customFields = Object.entries(this.customFields).map(([key, value]) => ({
            fieldId: key,
            value: value,
          }));
          task.typeId = this.taskTypeId;
          if (task.parent == '0') task.parent = null;

          if (this.isBulk) {
            let selectedChanges = $deepCompare(this.selectedCemented, this.selected);
            delete selectedChanges.customFields;
            let customFieldsChanges = $deepCompare(this.customFieldsCemented, this.customFields);
            customFieldsChanges = Object.entries(customFieldsChanges).map(([key, value]) => ({
              fieldId: key,
              value: value,
            }));

            this.tasksArray.forEach((task) => {
              // Apply selectedChanges to the task
              for (const [key, change] of Object.entries(selectedChanges)) {
                const keys = key.split('.');
                let obj = task;
                for (let i = 0; i < keys.length - 1; i++) {
                  obj = obj[keys[i]];
                }
                obj[keys[keys.length - 1]] = change.newValue;
              }

              // Apply customFieldsChanges to the task's customFields
              customFieldsChanges.forEach((change) => {
                let fieldObj = {
                  fieldId: change.fieldId,
                  value: change.value.newValue,
                };
                if (!task.customFields.length) {
                  fieldObj = {
                    fieldId: change.fieldId,
                    value: change.value.newValue,
                  };
                  task.customFields.push(fieldObj);
                } else {
                  const customField = task.customFields.find(
                    (field) => field.fieldId === change.fieldId,
                  );
                  if (customField) {
                    customField.value = change.value.newValue;
                  } else {
                    task.customFields.push(fieldObj);
                  }
                }
              });
            });
            this.$store
              .dispatch('TASK/BULK', this.tasksArray)
              .then((res) => {
                let newTask = res.data;
                newTask.app_handled = true;
                let payLoad = {
                  task: newTask,
                  id: this.isNew ? this.task.id : newTask.id,
                  isNew: this.isNew,
                };
                this.closeUpdateSlideout();

                this.$emit('onEdit', payLoad);
              }, () => {
                // Refused: the store action already showed the one message. The dialog stays open
                // with the user's edits. (then's second argument: an error after a save is no refusal.)
                this.$emit('discard', task.id);
              })
              .finally(() => {
                this.slideouts.isLoading = false;
              });
          } else {
            this.$store
              .dispatch(this.isNew ? 'TASK/ADD' : 'TASK/UPDATE', task)
              .then(async (res) => {
                let newTask = res.data;
                newTask.app_handled = true;
                // Wave C-ι demo (task side): persist staged CML links now that the
                // task exists. Self-contained + error-swallowing - cannot break save.
                if (this.$refs.taskCmlLinks) {
                  await this.$refs.taskCmlLinks.commit((newTask && newTask.id) || this.task.id);
                }
                let payLoad = {
                  task: newTask,
                  id: this.isNew ? this.task.id : newTask.id,
                  isNew: this.isNew,
                };
                this.closeUpdateSlideout();

                if (this.fromIndexPage) {
                  //this.addToComponents(payLoad);
                }
                this.$emit('onEdit', payLoad);
              }, () => {
                // Refused: the store action already showed the one message. The dialog stays open
                // with the user's edits. (then's second argument: an error after a save is no refusal.)
                this.$emit('discard', task.id);
              })
              .finally(() => {
                this.slideouts.isLoading = false;
              });
          }
        });
      },
      mapEvent(event) {
        event.start_date = new Date(event.start_date);
        event.end_date = new Date(event.end_date);
        return event;
      },
      addToComponents(payLoad) {
        if (this.$route.path.includes('gantt') && gantt) {
          if (!payLoad.isNew) return;

          gantt.addTask(payLoad.task, payLoad.task.parent);
        }
        if (this.$route.path.includes('schedule') && scheduler) {
          if (!payLoad.isNew) return;

          let event = this.mapEvent(payLoad.task);
          scheduler.addEvent(event);
          return;
        }
      },
      closeUpdateSlideout() {
        this.forgetOpenTask();
        this.selected = {};
        this.customFields = {};
        this.slideouts.scopesDirty = false;
        this.isFetching = false;
        this.cementTask();
        this.slideouts.active = false;
        this.valid = true;
        this.$refs.editTaskForm.resetValidation();
        if (this.$refs.comments) {
          this.$refs.comments.commenting = false;
        }
      },
      formatTask(task) {
        task.start_date = moment(task.start_date).format('YYYY-MM-DD');
        task.end_date = moment(task.end_date).format('YYYY-MM-DD');
        if (task.actualStartDate)
          task.actualStartDate = moment(task.actualStartDate).format('YYYY-MM-DD');
        if (task.actualEndDate)
          task.actualEndDate = moment(task.actualEndDate).format('YYYY-MM-DD');
        return task;
      },
      /** Tells the assistant which task is open ("add this to that WO"); not for a new task or a bulk edit. */
      rememberOpenTask(data) {
        this.forgetOpenTask();
        const task = data && !data.isNew && !data.isBulk ? data.task : null;
        if (!task || !task.id) return;
        this.unregisterOpenTask = registerOpenTask({ id: task.id, name: taskSubjectName(task) });
      },
      forgetOpenTask() {
        if (this.unregisterOpenTask) this.unregisterOpenTask();
        this.unregisterOpenTask = null;
      },
      open(data) {
        this.rememberOpenTask(data);
        this.selectedTab = 0;
        this.selected = {};
        this.slideouts.active = true;
        this.isBulk = data.isBulk;
        setTimeout(() => {
          this.fetchTask();
        }, 100);
        this.task = data.task;
        this.isNew = data.isNew;
        this.taskTypeId = data.taskTypeId;
        this.addToGantt = data.addToGantt;
        // Pre-link scopes when opened from a monitoring row (else []).
        this.seedCmlScopes = data.seedCmlScopes || [];
        // Force the monitoring-scope builder to remount + reload for this open,
        // even when reopening the same task (taskId alone wouldn't change).
        this.scopeBuilderKey += 1;
      },
      fillCustomField(data) {
        this.customFields =
          data?.customFields?.reduce((obj, item) => {
            const field = this.fields.find((elm) => elm.id == item.fieldId);
            if (field) {
              obj[item.fieldId] =
                field.fieldType == TaskFieldType.Date && item.value
                  ? moment(item.value).format('YYYY-MM-DD')
                  : field.fieldType == TaskFieldType.Boolean ||
                    field.fieldType == TaskFieldType.Number
                  ? Number(item.value)
                  : item.value;
            }

            return obj;
          }, {}) || {};
      },
      onSelectedTabChanged(tab) {
        setTimeout(() => {
          if (!this.task) return;
          if (tab == 1) this.$refs.comments.open(this.task.id);
          if (tab == 2) this.$refs.history.open(this.task.id);
          if (tab == 3) this.$refs.documents.open(this.task.id);
        });
      },
      $formatDate,
      fetchTask() {
        this.isFetching = true;
        this.slideouts.isLoading = true;
        this.selected = {};
        if (this.isBulk) {
          ApiService.getCollection(this.selectedTasks)
            .then((resp) => {
              this.isFetching = false;
              this.slideouts.isLoading = false;
              this.tasksArray = [...resp.data];
              const tasksArray = [...resp.data];
              let tasksCollection = [];
              let tempSelected = {};
              tasksArray.forEach((task) => {
                const data = structuredClone(this.formatTask(task));
                if (data.customFields) this.fillCustomField(data);
                if (!data.statusId && this.taskType.statuses.length > 0) {
                  data.statusId = this.taskType.statuses[0].id;
                }
                tasksCollection.push(data);
              });

              // Loop through each attribute of the first item in the array
              Object.keys(tasksCollection[0]).forEach((attribute) => {
                if (attribute !== 'customFields') {
                  if (this.checkAttributes(tasksCollection, attribute)) {
                    tempSelected[attribute] = tasksCollection[0][attribute];
                  }
                } else {
                  // Collect all unique custom field IDs
                  const customFieldIds = [
                    ...new Set(
                      tasksCollection.flatMap((task) =>
                        task.customFields.map((field) => field.fieldId),
                      ),
                    ),
                  ];
                  let customFieldsArray = [];
                  // Loop through each custom field ID
                  customFieldIds.forEach((fieldId) => {
                    if (this.checkCustomFieldsAttributes(tasksCollection, fieldId)) {
                      const customField = tasksCollection[0].customFields.find(
                        (field) => field.fieldId === fieldId,
                      );
                      customFieldsArray.push({
                        fieldId: customField.fieldId,
                        value: customField.value,
                        fieldType: customField.fieldType,
                      });
                      tempSelected.customFields = customFieldsArray;
                    }
                  });

                  // Fill customField object

                  if (tempSelected.customFields) this.fillCustomField(tempSelected);
                }
              });
              this.selected = structuredClone(tempSelected);
              this.cementTask();
            })
            .catch((err) => {
              this.isFetching = false;
              this.closeUpdateSlideout();
              $handleError(err);
            });
        }

        if (this.isNew) {
          ApiService.getNextId().then((e) => {
            let task = structuredClone(this.formatTask(this.task));
            if (task) task.friendlyId = e.data.nextId;

            if (this.taskType.statuses.length > 0&&!task.statusId) {
              task.statusId = this.taskType.statuses[0].id;
            }
            this.selected = task;
            this.$refs.editTaskForm.resetValidation();
            this.isFetching = false;
            this.slideouts.isLoading = false;
          });

          this.cementTask();
          return;
        }
        ApiService.getById(this.task.id)
          .then((resp) => {
            this.isFetching = false;
            this.slideouts.isLoading = false;
            const data = structuredClone(this.formatTask(resp.data));
            if (data.customFields) this.fillCustomField(data);

            if (!data.statusId && this.taskType.statuses.length > 0) {
              data.statusId = this.taskType.statuses[0].id;
            }
            this.selected = data;

            this.cementTask();
          })
          .catch((err) => {
            this.isFetching = false;
            this.closeUpdateSlideout();
            $handleError(err);
          });
      },
      cementTask() {
        this.selectedCemented = structuredClone(this.selected);
        this.customFieldsCemented = structuredClone(this.customFields);
        this.checkForChanges();
      },
      checkForChanges() {
        if (!this.slideouts.active) return;

        this.slideouts.hasChanges =
          !$isEqual(this.selected, this.selectedCemented) ||
          !$isEqual(this.customFields, this.customFieldsCemented);
      },
      onAddComment(comment) {
        this.task.comments.push(comment);
        this.$emit('onEdit', { task: this.task, id: this.task.id, isNew: false });
      },
      onUpdateComment(comment) {
        // Find and update the comment in the task's comments array
        const commentIndex = this.task.comments.findIndex(c => c.id === comment.id);
        if (commentIndex !== -1) {
          this.task.comments[commentIndex] = comment;
        }
        this.$emit('onEdit', { task: this.task, id: this.task.id, isNew: false });
      },
      onDeleteComment(comment) {
        // Remove the comment from the task's comments array
        const commentIndex = this.task.comments.findIndex(c => c.id === comment.id);
        if (commentIndex !== -1) {
          this.task.comments.splice(commentIndex, 1);
        }
        this.$emit('onEdit', { task: this.task, id: this.task.id, isNew: false });
      },
      OnResize() {
        let editTaskSlideOut = this.$refs.taskSlideout;
        this.sideOutCurrentSize = editTaskSlideOut.resizeValue;
      },
      clearTaskColor() {
        this.selected.color = null;
      },
    },
    watch: {
      'slideouts.active'(active) {
        if (active) this.tagPickerRequested = true;
        // The slide-out can close itself (:visible.sync) without closeUpdateSlideout.
        else this.forgetOpenTask();
      },
      selected: {
        handler() {
          this.checkForChanges();
        },
        deep: true,
      },
      taskColor: {
        handler() {
          if (this.taskColor && this.taskColor?.hex) {
            this.selected.color = this.taskColor?.hex;
          }
        },
        deep: true,
      },
      customFields: {
        handler() {
          this.checkForChanges();
        },
        deep: true,
      },
      nested: {
        handler() {
          this.nested ? (this.sideOutCurrentSize = '80vw') : (this.sideOutCurrentSize = '35vw');
          this.nested ? (this.sideOutMinSize = '80vw') : (this.sideOutMinSize = '35vw');
        },
        deep: true,
      },
    },
    components: {
      DatePicker,
      TaskComments,
      TaskHistory,
      TaskDocuments,
      UserSelector,
      ForgeTagsSelector,
      SingleValueSelector,
      ColorPickerButton,
      TaskCmlLinksSection,
    },
  };
</script>
<style lang="scss">
  #edit-task-slideout {
    .title {
      margin: 10px 5px;
    }
    #EditTabs-wrapper {
      .v-tab {
        border-bottom: 1px solid var(--v-light-grey-base);
      }
      .v-tabs-items {
        height: 100% !important;
      }
    }

    .v-window-item {
      height: 100% !important;
      overflow-y: auto;
    }
    .v-window-item--active {
      height: 100% !important;
    }
    .v-window__container {
      height: 100% !important;
    }
    .vue-slideout-layout {
      background-color: #fcfdfc;
    }
    .vue-slideout-header {
      padding: 20px 35px !important;
      .sideOutHeaderTitle {
        font-size: 20px;
        font-weight: 600;
        line-height: 24px;
        color: var(--v-mid-grey2-base);
      }
    }
    .v-slider__thumb {
      width: 20px;
      height: 20px;
      border: 1px solid var(--v-primary-base);
      background-color: var(--v-bg_force_white-base) !important;
    }
    .v-slider__thumb:before {
      width: 30px;
      height: 30px;
      left: -6px;
      top: -6px;
    }
    .v-slider--horizontal .v-slider__track-container {
      height: 12px;
      border-radius: 10px !important;
    }
    .v-slider__track-background,
    .v-slider__track-fill {
      border-radius: 10px;
    }
    .sliderContainer {
      label {
        font-size: 16px;
      }
      .progressValue {
        font-size: 18px;
      }
    }
    .editTaskPanels .v-expansion-panel {
      padding: 10px 15px;
      border-radius: 7px;
      border: 1px solid var(--v-light-grey-base);
      margin-bottom: 10px;
      .v-expansion-panel-header {
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        padding: 0px;
        color: var(--v-mid-grey2-base);
        border: none;
      }
      .v-expansion-panel-content__wrap {
        padding: 0 0px 16px;
      }
      .v-expansion-panel--active
        > .v-expansion-panel-header--active
        .v-expansion-panel-header__icon:not(.v-expansion-panel-header__icon--disable-rotate)
        .v-icon {
        transform: rotate(90deg);
      }
      .v-text-field.v-input--is-readonly.v-text-field--outlined fieldset {
        border-style: solid !important;
      }
    }
    .vue-slideout-header {
      border-bottom: 0px !important;
    }
    .vue-slideout-footer {
      border-top: 0px !important;
    }

    #EditTabs-wrapper {
      & .v-window.v-tabs-items {
        height: 100%;
      }
    }

    .v-expansion-panel .v-expansion-panel-content {
      border: none;
    }

    .color-border {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 1px solid var(--v-light-grey-base);
    }
  }
</style>
